import useTypesafeAnswer from './useTypesafeAnswer';
import useCardEligibilityQuery from './useCardEligibility';
const mapToCardholder = (eligibleCards) => ({
    id: eligibleCards.paymentInstrumentReferenceId,
    name: `${eligibleCards['cipher.firstName']} ${eligibleCards['cipher.lastName']}`,
    last4digits: eligibleCards.cardLast4
});
export const sortByName = (a, b) => a.name.localeCompare(b.name);
const useCardholders = (step) => {
    var _a, _b;
    const { data: eligibleCards, isLoading: eligibleCardsLoading } = useCardEligibilityQuery();
    const authorizedCardholders = (_a = eligibleCards === null || eligibleCards === void 0 ? void 0 : eligibleCards.cards.map(mapToCardholder).sort(sortByName)) !== null && _a !== void 0 ? _a : [];
    const cardholders = authorizedCardholders.filter(cardholder => cardholder.id);
    const { currentAnswer } = useTypesafeAnswer(step);
    // Clone cardholders since it's an Immer object (cannot be mutated by .sort())
    const selectedCardholdersCopy = [...((_b = currentAnswer === null || currentAnswer === void 0 ? void 0 : currentAnswer.value) !== null && _b !== void 0 ? _b : [])]; // Avoid spreading a possible 'undefined'
    const selectedCardholders = selectedCardholdersCopy.sort(sortByName);
    return {
        cardholders,
        selectedCardholders,
        isLoading: eligibleCardsLoading
    };
};
export default useCardholders;
//# sourceMappingURL=useCardholders.js.map